import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

export const STUDIO_LABELS = {
  enregistrement: "FNK STUDIO",
  media: "FNK FILMS",
};

export const STUDIO_SUBTITLES = {
  enregistrement: "Enregistrement · Mix · Master · Beatmaking",
  media: "Podcasts · Vidéo · Photo · Book · Clips · Interview",
};

export const STUDIO_LOGOS = {
  enregistrement: "/logo-fenek-studio.jpg",
  media: "/logo-fenek-films.jpg",
};

export const STATUS_LABELS = {
  en_attente_validation: "En attente de validation",
  en_attente_paiement: "En attente de paiement",
  confirmee: "Confirmée · Payée",
  reservee: "Confirmée · Paiement sur place",
  annulee: "Annulée",
};

export const CATEGORY_LABELS = {
  studio: "Sessions studio",
  complement: "Compléments de session",
  beatmaking_catalogue: "Beatmaking — Prods du catalogue (Phase A)",
};

export const formatEuro = (amount) => {
  if (amount === null || amount === undefined) return "—";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatHour = (hour) => `${String(hour % 24).padStart(2, "0")}:00`;
export const formatEndHour = (hour) =>
  hour > 24 ? `${String(hour - 24).padStart(2, "0")}:00 (+1j)` : hour === 24 ? "00:00" : formatHour(hour);

export const toDateString = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};
